import React from "react"

export const AppliedMathIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.18233 9.92234C5.3266 9.77807 5.56079 9.7786 5.70506 9.92287C5.84912 10.0672 5.84926 10.3009 5.70506 10.4451L4.80059 11.349L5.71096 12.2594C5.85518 12.4036 5.85455 12.6378 5.71042 12.7821C5.56614 12.9263 5.33248 12.9264 5.18822 12.7821L4.27786 11.8717L3.36749 12.7821C3.22324 12.9264 2.98957 12.9263 2.84529 12.7821C2.70114 12.6378 2.70052 12.4036 2.84476 12.2594L3.75512 11.349L2.85065 10.4451C2.70644 10.3009 2.70657 10.0672 2.85065 9.92287C2.99493 9.7786 3.22912 9.77806 3.37339 9.92234L4.27786 10.8268L5.18233 9.92234Z"
        fill="#37474F"
      />
      <path
        d="M11.3511 12.2497C11.5544 12.2506 11.7189 12.4162 11.7189 12.6197C11.7189 12.8233 11.5542 12.9885 11.3506 12.9891C11.147 12.9886 10.9823 12.8234 10.9823 12.6197C10.9824 12.4158 11.1473 12.2498 11.3511 12.2497Z"
        fill="#37474F"
      />
      <path
        d="M13.0078 10.889C13.2119 10.889 13.3772 11.0549 13.3772 11.2589C13.3771 11.4628 13.2118 11.6278 13.0078 11.6278H9.70252C9.49859 11.6278 9.33328 11.4628 9.33312 11.2589C9.33312 11.0549 9.49849 10.889 9.70252 10.889H13.0078Z"
        fill="#37474F"
      />
      <path
        d="M11.3511 9.52774C11.5544 9.52861 11.7189 9.69418 11.7189 9.89767C11.7189 10.1013 11.5542 10.266 11.3506 10.2665C11.147 10.2661 10.9824 10.1014 10.9823 9.89767C10.9823 9.69372 11.1472 9.52786 11.3511 9.52774Z"
        fill="#37474F"
      />
      <path
        d="M4.28161 2.25608C4.48559 2.25608 4.65146 2.42098 4.65155 2.62494V3.90417H5.93078C6.13471 3.90429 6.29964 4.07015 6.29964 4.27411C6.29956 4.478 6.13466 4.64285 5.93078 4.64297H4.65155V5.93078C4.65144 6.13472 4.48558 6.29964 4.28161 6.29964C4.07768 6.29959 3.91285 6.13469 3.91275 5.93078V4.64297H2.62494C2.42102 4.6429 2.25616 4.47803 2.25608 4.27411C2.25608 4.07012 2.42097 3.90424 2.62494 3.90417H3.91275V2.62494C3.91284 2.42101 4.07768 2.25612 4.28161 2.25608Z"
        fill="#37474F"
      />
      <path
        d="M13.0078 3.90417C13.2119 3.90417 13.3772 4.07007 13.3772 4.27411C13.3771 4.47808 13.2118 4.64297 13.0078 4.64297H9.70252C9.49853 4.64297 9.33319 4.47808 9.33312 4.27411C9.33312 4.07007 9.49849 3.90417 9.70252 3.90417H13.0078Z"
        fill="#37474F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1794 0C14.4916 0.000245527 15.5553 1.06398 15.5556 2.37617V13.1794C15.5553 14.4916 14.4916 15.5553 13.1794 15.5556H2.37617C1.06398 15.5553 0.000245527 14.4916 0 13.1794V2.37617C0.000246153 1.06398 1.06398 0.000246153 2.37617 0H13.1794ZM1.15216 13.1794C1.15241 13.8552 1.70038 14.4031 2.37617 14.4034H7.19446V8.3611H1.15216V13.1794ZM8.3611 14.4034H13.1794C13.8552 14.4031 14.4031 13.8552 14.4034 13.1794V8.3611H8.3611V14.4034ZM2.37617 1.15216C1.70037 1.15241 1.15241 1.70037 1.15216 2.37617V7.19446H7.19446V1.15216H2.37617ZM8.3611 7.19446H14.4034V2.37617C14.4031 1.70038 13.8552 1.15241 13.1794 1.15216H8.3611V7.19446Z"
        fill="#37474F"
      />
    </svg>
  )
}
